const themes = {};

export { themes };
//# sourceMappingURL=index.js.map
